import type { Label } from '@/types/gql.generated';
import { Box, type BoxProps, Flex } from '@/ui';
import { Pill } from './Pill';

type Props = BoxProps & {
  labels: Label[];
};

export const PillsList = ({ labels, ...props }: Props) => {
  return (
    <Flex gap="1" wrap="wrap" {...props}>
      {labels.map((label) => (
        <Box key={label.id} overflow="hidden">
          <Pill>{label.text}</Pill>
        </Box>
      ))}
    </Flex>
  );
};
